export const desktopWrapperStyle = {
    position: 'fixed',
    bottom: '0px',
    right: '20px',
    zIndex: 2147483647,
    borderRadius: '10px 10px 0 0',
    overflow: 'hidden',
    boxSizing: 'content-box',
    boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.25)'
};

export const desktopClosedWrapperStyleChat = {
    position: 'fixed',
    bottom: '0px',
    right: '0px',
    zIndex: 2147483647,
    minWidth: '400px',
    boxSizing: 'content-box',
    minHeight: '120px'
};

export const mobileClosedWrapperStyle = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    width: '64px',
    height: '64px',
    zIndex: 2147483647,
    boxSizing: 'border-box'
};

export const mobileOpenWrapperStyle = {
    position: 'fixed',
    top: '0px',
    left: '0px',
    right: '0px',
    bottom: '0px',
    width: '100%',
    height: '100%',
    zIndex: 2147483647,
    boxSizing: 'border-box',
    overflow: 'hidden',
    background: '#f6f8fc'
};

export const desktopTitleStyle = {
    height: '40px',
    lineHeight: '30px',
    fontSize: '20px',
    display: 'flex',
    alignItems: 'center',
    padding: '5px 0 5px 20px',
    color: '#fff',
    cursor: 'pointer'
};

export const mobileTitleStyle = {
    height: '40px',
    lineHeight: '30px',
    fontSize: '20px',
    display: 'flex',
    alignItems: 'center',
    padding: '5px 0 5px 20px',
    color: '#fff',
    cursor: 'pointer',
    webkitBoxShadow: '1px 1px 4px rgba(101,119,134,.75)',
    boxShadow: '1px 1px 4px rgba(101,119,134,.75)'
};


// WEBPACK FOOTER //
// ./src/widget/style.js